// extracted by mini-css-extract-plugin
module.exports = {"container":"WFNX","title":"REu_","sub__title":"szU_","main__title":"__1GYs","content":"__0B1k","more__button":"__3i2V","show__more":"d3gj"};